import * as customPropTypes from 'custom-prop-types';
import PropTypes from 'prop-types';
import React from 'react';

import { TextField } from '@/design-system/atoms/Forms/TextField';
import { LazyIconSearch } from '@/design-system/atoms/Icons/IconSearch/Lazy';
import { trackInteraction } from '@/utils/analytics';

import { useDirectoryContext } from '../../context/DirectoryContext';
import styles from '../../Directory.module.scss';

const DirectorySearchBar = ({ searchButtonAlt, inputFieldLabel, analytics, ...props }) => {
    const {
        coveo: {
            controller: { resultList },
        },
        handleSubmit,
    } = useDirectoryContext();

    const [searchValue, setSearchValue] = React.useState('');

    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        const unsubscribe = resultList.subscribe(() => {
            setIsLoading(resultList.state.isLoading);
        });

        return () => {
            // Unsubscribe from the query summary state
            unsubscribe();
        };
    }, [resultList]);

    const handleSetSearchValue = React.useCallback(
        (value) => {
            if (!value) {
                handleSubmit(value);
            }
            setSearchValue(value);
        },
        [handleSubmit],
    );

    const submitForm = (event) => {
        event.preventDefault();
        if (searchValue) {
            //analytics
            trackInteraction({
                interactionType: 'search_results',
                selector: 'search',
                searchTerm: searchValue,
                ...analytics,
            });
        }
        handleSubmit(searchValue);
    };

    return (
        <form className={styles[`directiory__form`]} onSubmit={submitForm} data-trigger="search">
            <TextField
                label={inputFieldLabel}
                value={searchValue}
                buttonProps={{
                    type: 'submit',
                    iconComponent: LazyIconSearch,
                    disabled: isLoading,
                    ariaLabel: searchButtonAlt,
                }}
                onChange={handleSetSearchValue}
            />
        </form>
    );
};

DirectorySearchBar.propTypes = {
    inputFieldLabel: PropTypes.string,
    analytics: customPropTypes.analyticsPropType,
};

export default DirectorySearchBar;
